import { lazy } from 'react';

import { withSuspense } from '@/shared/lib/hocs/with-suspense.hoc';

export const ForgotPasswordPage = withSuspense(lazy(() => import('./forgot-password-page.component')));
